(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if (!customElements.get('bart-announcement-carousel')) {
    class BartAnnouncementCarousel extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.bart-announcement__item')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.setAttribute('data-ready', '');
        this.show(0);
        this.onmouseenter = () => clearInterval(this.timer);
        this.onmouseleave = () => this.restart();
        this.onfocusin = () => clearInterval(this.timer);
        this.onfocusout = () => this.restart();
        this.onBlockSelect = event => {
          const index = this.slides.findIndex(slide => slide.contains(event.target));
          if (index >= 0) { this.show(index); this.paused = true; this.restart(); }
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.restart();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.toggleAttribute('data-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
      }
      restart() {
        clearInterval(this.timer);
        if (!this.paused && !this.matches(':hover') && !this.contains(document.activeElement)) {
          this.timer = setInterval(() => this.show(this.index + 1), 6000);
        }
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
    }
    customElements.define('bart-announcement-carousel', BartAnnouncementCarousel);
  }

  if (!customElements.get('bart-announcement-localization')) {
    class BartAnnouncementLocalization extends HTMLElement {
      connectedCallback() {
        const select = this.querySelector('select');
        const form = this.querySelector('form');

        if (select && form) {
          select.addEventListener('change', () => form.submit());
        }
      }
    }

    customElements.define('bart-announcement-localization', BartAnnouncementLocalization);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('bart-localization-form')) {
    class BartLocalizationForm extends HTMLElement {
      constructor() {
        super();
        const select = this.querySelector('select');
        const form = this.querySelector('form');

        if (select && form) {
          select.addEventListener('change', () => form.submit());
        }
      }
    }

    customElements.define('bart-localization-form', BartLocalizationForm);
  }

  if (!customElements.get('sticky-header')) {
    class BartStickyHeader extends HTMLElement {
      connectedCallback() {
        this.headerSection = document.getElementById('shopify-section-header');
        if (this.headerSection) {
          this.headerSection.classList.add('shopify-section-header-sticky');
        }
      }

      disconnectedCallback() {
        if (this.headerSection) {
          this.headerSection.classList.remove('shopify-section-header-sticky');
        }
      }

      reveal() {
        if (this.headerSection) {
          this.headerSection.classList.add('shopify-section-header-sticky');
        }
      }
    }

    customElements.define('sticky-header', BartStickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const sectionWrapper = this.closest('.shopify-section');

      if (sectionWrapper) {
        sectionWrapper.classList.add('product-recommendations-section');
      }

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');

              if (sectionWrapper) {
                sectionWrapper.classList.add('product-recommendations-section--loaded');
              }
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quotes"] && !Shopify.designMode) return;
  try {
    
(function($) {
    swipr = () => {
        if($('.quotes-slider').length) {          
            $(".quotes-slider").each(function(i) {
                let slides_per_view = $(this).attr('slidesperview');
                let pause_on_hover = $(this).attr('pauseonhover') ? true : false;
                let slide_delay = $(this).attr('slidedelay');
				let id = $(this).attr('slider-id');
                let swiper = new Swiper($(this)[0], {
                    loop: true,
                    slidesPerView: slides_per_view,
                    spaceBetween: 20,
                    autoplay: {
                        delay: slide_delay,
                    },
                  pagination: {
                    el: '#pagination-' + id + '-btn',
                    clickable: true
                  },
                  navigation: {
                    nextEl: '#next-' + id + '-btn',
                    prevEl: '#prev-' + id + '-btn'
                  },
              // Responsive breakpoints
                breakpoints: {
                  // when window width is >= 320px
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20
                  },
                  // when window width is >= 480px
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 30
                  },
                  // when window width is >= 640px
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 40
                  }
                }
                });
            });
        }
    };
     
    document.addEventListener("DOMContentLoaded", () => { swipr() }); 
})(jQuery);


  } catch(e) { console.error(e); }
})();
})();
